import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendMoney = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10,
		r: 10,
		fill: "#1E63FF",
		fillOpacity: .1
	}), /* @__PURE__ */ _jsxs("g", {
		opacity: .8,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M11 7L13.4453 10L11 13",
			stroke: "#1E63FF"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M13 10.0557L6 10.0557",
			stroke: "#1E63FF"
		})]
	})]
});
export default SvgSendMoney;
